import React from 'react';
import moment from 'moment';
import { useQuery } from '@apollo/client';

// import { QUERY_STATE } from 'quanta-flows/modules/quote/health';
import {GET_PLAN_COVER_DETAILS,QUERY_STATE} from '../../queries';

import {
  updateHealthQuotePlans,
  resetPlansChanged,
} from 'quanta-flows/modules/quote/health/state';

import QuoteData from './quote-data';
import ShowPlans from './show-plans';

export default function Plans({
  productName,
  productCode,
  lobCode,
  quoteNumber,
  goToStep,
  genderList,
  setStartStep,
  saveProceedDisplay
}) {
  const { data: queryStateData } = useQuery(QUERY_STATE);

  const { healthQuote ,selectedIntermediary} = queryStateData;
  //console.log(`selected intermediary:`,selectedIntermediary);

  const variables = {
    input: {
    sumInsured: healthQuote.cover.sum_insured,
    deductSumInsured:parseInt(healthQuote.deductSumInsured),
    startDate: moment().format('DD/MM/YYYY').toString(),
    productCode: productCode,
    imdCode:
      healthQuote?.intermediaryDetails?.code ||
      selectedIntermediary?.intermediaryCode,
    members: healthQuote.members
      .filter((mem) => mem.selected)
      .map((member) => {
        return {
          relationship: member.relationship,
          gender: member.gender,
          dob: member.dob,
          age: member.age.toString(),
        };
      }),
    },
  };
  const { loading: planLoading, error: planError } = useQuery(
    GET_PLAN_COVER_DETAILS,
    {
      variables,
      skip:
       (quoteNumber !== undefined || healthQuote?.quotationNo !== ''),
      onCompleted: (data) => {
        updateHealthQuotePlans(data.planAndCovers);
        resetPlansChanged();
      },
    },
  );

  return (
    <div>
      <QuoteData goToStep={goToStep} genderList={genderList} {...{
        productCode,
        productName,
        lobCode,
        quoteNumber,
        setStartStep,
        
      }}/>
      <ShowPlans
        planLoading={planLoading}
        planError={planError}
        genderList={genderList}
        productName={productName}
        productCode={productCode}
        lobCode={lobCode}
        quoteNumber={quoteNumber}
        selectedIntermediary={selectedIntermediary}
        saveProceedDisplay={saveProceedDisplay}
      />
    </div>
  );
}

